// Updated OurProfile.jsx with SEBI compliance and YouTube video integration
import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
// Import leadership image from assets
import leadershipImage from '../../assets/images/sunil3.jpg'; 

const OurProfile = () => {
  // YouTube video URLs - replace with your actual YouTube video URLs
  const youtubeUrl = 'https://www.youtube.com/watch?v=z7RCn3TKJeA&t=12s';
  const fullWidthVideoUrl = 'https://www.youtube.com/shorts/fjg8_EP9E_o'; // Replace with your new video URL
  
  // Enhanced function to convert YouTube URL to embed URL - supports all YouTube URL formats including Shorts
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return '';
    
    let videoId = '';
    
    // Handle different YouTube URL formats
    const patterns = [
      // YouTube Shorts URLs
      /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
      /(?:youtu\.be\/shorts\/)([a-zA-Z0-9_-]{11})/,
      // Standard watch URLs
      /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // Shortened youtu.be URLs
      /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
      // Embed URLs
      /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
      // Video URLs with additional parameters
      /(?:youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
      // User uploaded videos
      /(?:youtube\.com\/user\/.*\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // Channel videos
      /(?:youtube\.com\/channel\/.*\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // Playlist videos
      /(?:youtube\.com\/.*[?&]v=)([a-zA-Z0-9_-]{11})/,
      // Mobile URLs
      /(?:m\.youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      /(?:m\.youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
      // Gaming URLs
      /(?:gaming\.youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // YouTube Music URLs
      /(?:music\.youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/,
      // Attribution links
      /(?:youtube\.com\/attribution_link\?.*v=)([a-zA-Z0-9_-]{11})/
    ];
    
    // Try each pattern to extract video ID
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        videoId = match[1];
        break;
      }
    }
    
    // If no video ID found, try the fallback regex
    if (!videoId) {
      const fallbackRegex = /[?&]v=([a-zA-Z0-9_-]{11})/;
      const fallbackMatch = url.match(fallbackRegex);
      if (fallbackMatch && fallbackMatch[1]) {
        videoId = fallbackMatch[1];
      }
    }
    
    // Return embed URL with video ID
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&showinfo=0&controls=1&fs=1`;
    }
    
    // If already an embed URL, return as is
    if (url.includes('youtube.com/embed/')) {
      return url;
    }
    
    return '';
  };

  const styles = {
    pageContainer: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    },
    section: {
      padding: '4rem 0',
      backgroundColor: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      flex: 1
    },
    // New full-width video section styles
    fullWidthVideoSection: {
      padding: '4rem 0',
      backgroundColor: '#1f2937',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    },
    fullWidthVideoContainer: {
      maxWidth: '100%',
      margin: '0 auto',
      padding: '0'
    },
    videoHeader: {
      textAlign: 'center',
      marginBottom: '3rem',
      padding: '0 2rem'
    },
    videoTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '1.2',
      margin: '0 0 1rem 0',
      letterSpacing: '-0.02em'
    },
    videoSubtitle: {
      fontSize: '1.1rem',
      color: '#d1d5db',
      lineHeight: '1.6',
      margin: '0',
      maxWidth: '600px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    fullWidthVideoWrapper: {
      position: 'relative',
      width: '100%',
      backgroundColor: '#111827',
      paddingBottom: '56.25%', // 16:9 aspect ratio
      height: '0',
      overflow: 'hidden'
    },
    fullWidthYoutubeEmbed: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      border: 'none'
    },
    missionVisionSection: {
      padding: '4rem 0',
      backgroundColor: '#f8fafc',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    },
    container: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 2rem'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '6rem',
      alignItems: 'flex-start'
    },
    missionVisionGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 350px',
      gap: '6rem',
      alignItems: 'center'
    },
    leftColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem'
    },
    missionVisionContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '3rem'
    },
    mainHeading: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: '#1a1a1a',
      lineHeight: '1.1',
      margin: '0 0 2rem 0',
      letterSpacing: '-0.02em'
    },
    sectionHeading: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#1a1a1a',
      lineHeight: '1.2',
      margin: '0 0 1.5rem 0',
      letterSpacing: '-0.02em'
    },
    contentText: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      marginBottom: '2rem'
    },
    missionVisionBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    paragraph: {
      color: '#6b7280',
      lineHeight: '1.7',
      margin: '0',
      fontSize: '1.1rem'
    },
    missionVisionText: {
      color: '#6b7280',
      lineHeight: '1.7',
      margin: '0',
      fontSize: '1.15rem'
    },
    brandName: {
      color: '#22c55e',
      fontWeight: '600'
    },
    rightColumn: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '2rem'
    },
    // Updated YouTube video container styles
    videoContainer: {
      position: 'relative',
      width: '100%',
      borderRadius: '1rem',
      overflow: 'hidden',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#f8fafc',
      paddingBottom: '56.25%', // 16:9 aspect ratio
      height: '0'
    },
    youtubeEmbed: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: '1rem'
    },

    // Mission Vision image styles (keeping existing)
    missionVisionImageContainer: {
      position: 'relative',
      borderRadius: '1rem',
      overflow: 'hidden',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#f8fafc'
    },
    missionVisionImage: {
      width: '100%',
      height: 'auto',
      display: 'block',
      borderRadius: '1rem',
      objectFit: 'cover'
    },
    imageOverlay: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
      padding: '2rem',
      color: 'white'
    },
    overlayText: {
      fontSize: '1.1rem',
      fontWeight: '600',
      margin: '0'
    },
    disclaimer: {
      fontSize: '0.875rem',
      color: '#6b7280',
      fontStyle: 'italic',
      marginTop: '2rem',
      padding: '1.5rem',
      backgroundColor: '#f9fafb',
      borderRadius: '0.75rem',
      border: '1px solid #e5e7eb',
      lineHeight: '1.5'
    }
  };

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .mission-vision-image:hover {
          transform: scale(1.02) !important;
          transition: transform 0.3s ease !important;
        }
        

        @media (max-width: 1024px) {
          .responsive-grid {
            grid-template-columns: 1fr !important;
            gap: 4rem !important;
          }
          .responsive-mission-grid {
            grid-template-columns: 1fr !important;
            gap: 3rem !important;
          }
          .responsive-heading {
            font-size: 3rem !important;
          }
          .responsive-section-heading {
            font-size: 2rem !important;
          }
          .responsive-video-title {
            font-size: 2rem !important;
          }
          .responsive-container {
            padding: 0 1.5rem !important;
          }
        }
        
        @media (max-width: 768px) {
          .responsive-container {
            padding: 0 1rem !important;
          }
          .responsive-grid {
            gap: 3rem !important;
          }
          .responsive-mission-grid {
            gap: 2rem !important;
          }
          .responsive-heading {
            font-size: 2.5rem !important;
          }
          .responsive-section-heading {
            font-size: 1.8rem !important;
          }
          .responsive-video-title {
            font-size: 1.8rem !important;
          }
          .responsive-right {
            padding-top: 0 !important;
          }
          .responsive-mission-content {
            gap: 2rem !important;
          }
          .responsive-video-header {
            padding: 0 1rem !important;
            margin-bottom: 2rem !important;
          }
        }
        
        @media (max-width: 640px) {
          .responsive-heading {
            font-size: 2rem !important;
          }
          .responsive-section-heading {
            font-size: 1.6rem !important;
          }
          .responsive-video-title {
            font-size: 1.6rem !important;
          }
          .responsive-text {
            font-size: 1rem !important;
          }
          .responsive-mission-text {
            font-size: 1rem !important;
          }
        }
      `}</style>
      
      <div style={styles.pageContainer}>
        {/* Header */}
        <Header />
        
        {/* Main Content */}
        <main>
          {/* How We Started Section */}
          <section style={styles.section}>
            <div style={{...styles.container}} className="responsive-container">
              <div style={{...styles.grid}} className="responsive-grid">
                {/* LEFT COLUMN - Profile Content */}
                <div style={styles.leftColumn}>
                  <h1 style={{...styles.mainHeading}} className="responsive-heading">
                    About WinNest
                  </h1>
                  
                  <div style={styles.contentText}>
                    <p style={{...styles.paragraph}} className="responsive-text">
                      <span style={styles.brandName}>WinNest</span> is an AMFI Registered Mutual Fund Distributor (ARN-81431) specializing in mutual fund distribution and financial planning services. 
                      Our range of financial solutions is designed to align with each client's specific financial objectives and risk profile, 
                      covering areas such as tax planning, wealth management assistance, and insurance planning services.
                    </p>
                    <p style={{...styles.paragraph}} className="responsive-text">
                      <span style={styles.brandName}>WinNest</span> aims to support you in working towards your financial goals, whether they are 
                      short-term objectives like expense planning or long-term aspirations such as retirement planning. 
                      We believe in providing guidance that helps you make informed investment decisions.
                    </p>
                    <p style={{...styles.paragraph}} className="responsive-text">
                      As life progresses, financial needs and goals evolve. Our qualified Mutual Fund advisors and financial planners 
                      can provide guidance to help you navigate your investment journey with appropriate risk assessment and 
                      portfolio diversification strategies, subject to market conditions and individual circumstances.
                    </p>
                  </div>
                </div>

                {/* RIGHT COLUMN - YouTube Video */}
                <div style={{...styles.rightColumn}} className="responsive-right">
                  {/* YouTube Video Embed - Commented out as requested */}
                  {/* <div style={styles.videoContainer}>
                    <iframe
                      src={getYouTubeEmbedUrl(youtubeUrl)}
                      title="WinNest Company Introduction"
                      style={styles.youtubeEmbed}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </section>

          {/* Full Width Video Section - Before Investment Philosophy */}
          <section style={styles.fullWidthVideoSection}>
            <div style={styles.fullWidthVideoContainer}>
              {/* Full Width Video */}
              <div style={styles.fullWidthVideoWrapper}>
                <iframe
                  src={getYouTubeEmbedUrl(fullWidthVideoUrl)}
                  title="WinNest Company Video"
                  style={styles.fullWidthYoutubeEmbed}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </section>

          {/* Investment Philosophy Section Header */}
          <section style={styles.missionVisionSection}>
            <div style={{...styles.container}} className="responsive-container">
              <div style={{textAlign: 'center', marginBottom: '3rem'}}>
                <h2 style={{...styles.sectionHeading}} className="responsive-section-heading">
                  Our Investment Philosophy
                </h2>
                <p style={{...styles.missionVisionText, maxWidth: '800px', margin: '0 auto'}} className="responsive-mission-text">
                  Discover how WinNest approaches wealth management and mutual fund distribution with a focus on 
                  long-term financial success and regulatory compliance.
                </p>
              </div>
            </div>
          </section>

          {/* Mission & Vision Section */}
          <section style={styles.missionVisionSection}>
            <div style={{...styles.container}} className="responsive-container">
              <div style={{...styles.missionVisionGrid}} className="responsive-mission-grid">
                {/* LEFT COLUMN - Mission & Vision Content */}
                <div style={{...styles.missionVisionContent}} className="responsive-mission-content">
                  {/* Mission Block */}
                  <div style={styles.missionVisionBlock}>
                    <h2 style={{...styles.sectionHeading}} className="responsive-section-heading">
                      Our Mission
                    </h2>
                    <p style={{...styles.missionVisionText}} className="responsive-mission-text">
                      Our mission is to assist our clients in working towards their long-term financial objectives through 
                      transparent, ethical, and professional mutual fund distribution services. We strive to provide comprehensive 
                      guidance and support to help our clients make informed investment decisions that align with their 
                      individual risk profiles and financial goals, subject to market conditions.
                    </p>
                  </div>

                  {/* Vision Block */}
                  <div style={styles.missionVisionBlock}>
                    <h2 style={{...styles.sectionHeading}} className="responsive-section-heading">
                      Our Vision
                    </h2>
                    <p style={{...styles.missionVisionText}} className="responsive-mission-text">
                      Our vision is to be a trusted and reliable partner in our clients' financial journey, while maintaining 
                      the highest standards of regulatory compliance and professional ethics. We aspire to contribute positively 
                      to our clients' financial well-being through sound investment guidance and continuous professional development.
                    </p>
                  </div>
                </div>

                {/* RIGHT COLUMN - Mission & Vision Image */}
                <div style={styles.missionVisionImageContainer} className="mission-vision-image">
                  <img 
                    src={leadershipImage}
                    alt="Our Leadership - Professional in business attire"
                    style={styles.missionVisionImage}
                    onError={(e) => {
                      // Fallback if image doesn't exist
                      e.target.style.display = 'none';
                      e.target.parentNode.innerHTML = `
                        <div style="
                          width: 100%; 
                          height: 400px; 
                          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: white;
                          font-size: 1.2rem;
                          font-weight: 600;
                          text-align: center;
                          border-radius: 1rem;
                        ">
                          <div>
                            <div style="font-size: 3rem; margin-bottom: 1rem;">🏢</div>
                            <div>Professional Excellence</div>
                            <div style="font-size: 0.9rem; opacity: 0.9; margin-top: 0.5rem;">
                              AMFI-Registered Advisory Services
                            </div>
                          </div>
                        </div>
                      `;
                    }}
                  />
                  
                  {/* Optional overlay with additional info */}
                  <div style={styles.imageOverlay}>
                    <p style={styles.overlayText}>
                      Regulated & Professional Service
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default OurProfile;